// extracted by mini-css-extract-plugin
export var BtnFilled = "Button-module--BtnFilled--XIn+d";
export var BtnOutline = "Button-module--BtnOutline--1olCx";